import { createFileRoute, redirect } from '@tanstack/react-router'
import { BranchList } from '@/features/branches/branch-list'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the branches screen (REQ-09).
 *
 * The grant gate is presentation only — the API enforces `company.view` on
 * the branch endpoints; this only keeps a user without the grant out of a
 * screen they cannot use. Branches reuse the company permission keys rather
 * than adding a pair of their own, so this matches `departments.tsx` exactly.
 */
export const Route = createFileRoute('/_authenticated/branches')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'company.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: BranchList,
})
